// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ProjectPersonnelClaimsEmployeeSummary  {
    _originalTypeClassName = "Loom.BO.ProjectPersonnelClaimsEmployeeSummary";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ProjectPersonnelClaimsEmployeeSummary.translate = translateService;
}
this.EmployeeDetails = [];
this.SummaryDetails = [];
this.Id = null;
this.PersonHours = null;
this.PersonMonths = null;
this.Cost = null;
this.Employee = null;
this.DailyRateForPeriod = null;
this.DayEquivalents = null;
this.DayEquivalentsClaimed = null;
this.DayEquivalentsAvailable = null;
this.HourlyRateForPeriod = null;
this.DayEquivalentHours = null;
this.TotalPeriodEligibleCosts = null;
this.Project = null;
this.RoundedDayEquivalents = null;
this.CostFromSum = null;
this.PeriodDurationInMonths = null;
this.PeriodDurationInDayEquivalents = null;
this.WorkableDaysOfPeriod = null;
this.DaysTheEmployeeActuallyWorked = null;
this.EmployeeId = null;
this.EmploymentContractId = null;
this.ClaimDifference = null;
this.ProjectProgramme = null;
this.MaxDayEquivalentsInPeriod = null;
this.StartPeriodDate = null;
this.EndPeriodDate = null;
this.IsSummary = false;
this.UsedLastYearCosts = false;
this.TotalPeriodCostsForRateCalculation = null;
this.RateReferencePeriodStart = null;
this.RateReferencePeriodEnd = null;
this.IsProjectRPSummary = false;
this.TotalPeriodEmployeeCost = null;
this.UI_IsExpanded = false;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
PersonHours:any;
PersonMonths:any;
Cost:any;
Employee:any;
DailyRateForPeriod:any;
DayEquivalents:any;
DayEquivalentsClaimed:any;
DayEquivalentsAvailable:any;
HourlyRateForPeriod:any;
DayEquivalentHours:any;
TotalPeriodEligibleCosts:any;
Project:any;
RoundedDayEquivalents:any;
CostFromSum:any;
PeriodDurationInMonths:any;
PeriodDurationInDayEquivalents:any;
WorkableDaysOfPeriod:any;
DaysTheEmployeeActuallyWorked:any;
EmployeeId:any;
EmploymentContractId:any;
ClaimDifference:any;
ProjectProgramme:any;
MaxDayEquivalentsInPeriod:any;
StartPeriodDate:any;
EndPeriodDate:any;
IsSummary:any;
UsedLastYearCosts:any;
TotalPeriodCostsForRateCalculation:any;
RateReferencePeriodStart:any;
RateReferencePeriodEnd:any;
IsProjectRPSummary:any;
TotalPeriodEmployeeCost:any;
UI_IsExpanded:any;
Report:any;
EmployeeDetails:any;
EmploymentType:any;
SummaryDetails:any;
ProjectReportingPeriod:any;
static setReport = ($this, value) => {
var oldValue = $this.Report;
$this.Report = value;
if (value != null) {
if (oldValue != null) {
Domain.ProjectPersonnelClaimsReport.removePerEmployeeDetails(oldValue, $this);
}
Domain.ProjectPersonnelClaimsReport.addPerEmployeeDetails(value, $this);
}
}
static setEmployeeDetails = ($this, items) => {
                if (items == null) items = [];
                if ($this.EmployeeDetails == null) $this.EmployeeDetails = [];

                const copyItems = Common.cloneObject(items);

                while ($this.EmployeeDetails.length > 0) {
                    Domain.ProjectPersonnelClaimsEmployeeSummary.removeEmployeeDetails($this, $this.EmployeeDetails[0]);
                }

                Domain.ProjectPersonnelClaimsEmployeeSummary.addManyEmployeeDetails($this, copyItems);
            }
static addManyEmployeeDetails = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.ProjectPersonnelClaimsEmployeeSummary.addEmployeeDetails($this, items[i]);
                }
            }
static addEmployeeDetails = ($this, item) => {
                if ($this.EmployeeDetails == null) $this.EmployeeDetails = [];
                if (item == null || $this.EmployeeDetails.indexOf(item) > -1) return;
                $this.EmployeeDetails.push(item);
if (item.EmployeeProjectSummary != $this) {
Domain.ProjectPersonnelClaimsEmployeeDetail.setEmployeeProjectSummary(item, $this);
}
}
static addRangeEmployeeDetails = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.ProjectPersonnelClaimsEmployeeSummary.addEmployeeDetails($this, item));
            }
static removeEmployeeDetails = ($this, item) => {
                if ($this == null || $this.EmployeeDetails == null || $this.EmployeeDetails.indexOf(item) === -1) return;
                var _index = $this.EmployeeDetails.indexOf(item);
                $this.EmployeeDetails.splice(_index, 1);
item.EmployeeProjectSummary = null;
}
static clearEmployeeDetails = ($this) => { $this.EmployeeDetails = null; }
static setEmploymentType = ($this, value) => {
var oldValue = $this.EmploymentType;
$this.EmploymentType = value;
if (value != null) {
}
}
static setSummaryDetails = ($this, items) => {
                if (items == null) items = [];
                if ($this.SummaryDetails == null) $this.SummaryDetails = [];

                const copyItems = Common.cloneObject(items);

                while ($this.SummaryDetails.length > 0) {
                    Domain.ProjectPersonnelClaimsEmployeeSummary.removeSummaryDetails($this, $this.SummaryDetails[0]);
                }

                Domain.ProjectPersonnelClaimsEmployeeSummary.addManySummaryDetails($this, copyItems);
            }
static addManySummaryDetails = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.ProjectPersonnelClaimsEmployeeSummary.addSummaryDetails($this, items[i]);
                }
            }
static addSummaryDetails = ($this, item) => {
                if ($this.SummaryDetails == null) $this.SummaryDetails = [];
                if (item == null || $this.SummaryDetails.indexOf(item) > -1) return;
                $this.SummaryDetails.push(item);
}
static addRangeSummaryDetails = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.ProjectPersonnelClaimsEmployeeSummary.addSummaryDetails($this, item));
            }
static removeSummaryDetails = ($this, item) => {
                if ($this == null || $this.SummaryDetails == null || $this.SummaryDetails.indexOf(item) === -1) return;
                var _index = $this.SummaryDetails.indexOf(item);
                $this.SummaryDetails.splice(_index, 1);
}
static clearSummaryDetails = ($this) => { $this.SummaryDetails = null; }
static setProjectReportingPeriod = ($this, value) => {
var oldValue = $this.ProjectReportingPeriod;
$this.ProjectReportingPeriod = value;
if (value != null) {
}
}

static GetCost($this: any): any{if (($this?.Report?.DailyRatesCalculationMethod == Domain.DailyRateCalculationMethod.ActualCostsH2020)) {return Joove.Common.mathRound(Joove.Common.safeNumber($this?.PersonHours) * Joove.Common.safeNumber($this?.HourlyRateForPeriod), 2);}
return Joove.Common.mathRound(Joove.Common.safeNumber($this?.DayEquivalentsClaimed) * Joove.Common.safeNumber($this?.DailyRateForPeriod), 2);
}
static GetDayEquivalentsAvailable($this: any): any{return Joove.Common.safeNumber($this?.MaxDayEquivalentsInPeriod) - Joove.Common.safeNumber($this?.DayEquivalentsClaimed);
}
static GetPersonMonths($this: any): any{return Joove.Common.safeNumber($this?.PersonHours) / Joove.Common.safeNumber(173);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}